import React from "react";
import { useOutletContext } from "react-router-dom";
import { ErrorAlert } from "@cms/ui/components/error-alert";
import { useApiQuery } from "@cms/portal-lib/hooks";
import { PageHeader } from "@cms/ui/components/page-header";
import { FormsHeader } from "../components/forms-header";
import { SubmissionsInbox } from "../components/submissions-inbox";
import { fetchForms } from "../lib/forms";
import type { ClientOutletContext } from "../lib/outlet-context";

/** The Forms section's Inbox tab: everything visitors have sent you. */
export function FormsPage() {
  const { api, refreshStatus } = useOutletContext<ClientOutletContext>();

  // The inbox needs the form list to label fields and populate the filter.
  const forms = useApiQuery(() => (api ? fetchForms(api) : null), [api]);

  return (
    <div>
      <FormsHeader />
      <PageHeader
        title="Inbox"
        description="Everything visitors have sent you through your forms — read, filter and export it here."
      />

      <ErrorAlert error={forms.error} />

      <SubmissionsInbox
        api={api}
        forms={forms.data?.forms ?? []}
        assetsBaseUrl={forms.data?.assetsBaseUrl ?? null}
        refreshStatus={refreshStatus}
        reloadKey={0}
      />
    </div>
  );
}
